// 导入CryptoJS加密库
import CryptoJS from 'crypto-js';

// 签名工具类：用于生成API请求签名
export class Signature {
    // 签名密钥（注意：实际项目中应该从环境变量中获取）
    static secretKey = 'your_secret_key_here526fb87088aa9ac0bea25c0117f7e018';

    // 标准化数据：将请求数据转换为统一格式
    static normalizeData(data) {
        const normalized = {};
        // 递归展平数组，将多维嵌套结构展平为 key[index][sub] = value 的键值对
        Signature.flattenArray('', data, normalized, true);
        return normalized;
    }

    /**
     * 递归展平嵌套对象/数组
     * @param {string} prefix - 当前键名前缀
     * @param {*} value - 当前层级的值
     * @param {Object} result - 展平结果对象
     * @param {boolean} isRoot - 是否为根层级（根层级不添加前缀）
     */
    static flattenArray(prefix, value, result, isRoot = false) {
        if (Array.isArray(value)) {
            // 数组：展开为 prefix[index] 形式
            value.forEach((item, index) => {
                Signature.flattenArray(`${prefix}[${index}]`, item, result);
            });
        } else if (value !== null && typeof value === 'object') {
            // 对象（非 null、非数组）：展开为 prefix[key] 形式
            for (const [key, val] of Object.entries(value)) {
                const flatKey = isRoot ? key : `${prefix}[${key}]`;
                Signature.flattenArray(flatKey, val, result);
            }
        } else if (value === null || value === undefined) {
            // null/undefined 转为空字符串，与 PHP (string)null = "" 保持一致
            result[prefix] = '';
        } else {
            // 标量值（字符串、数字、布尔）：转为字符串
            if (typeof value === 'boolean') {
                result[prefix] = value ? '1' : '0';
            } else {
                result[prefix] = String(value);
            }
        }
    }

    /**
     * 生成签名
     * @param {Object} data - 请求数据对象
     * @param {number} timestamp - 时间戳（可选，默认使用当前时间）
     * @returns {string} SHA256签名字符串
     */
    static generateSignature(data, timestamp = null) {
        // 如果未提供时间戳，则生成当前时间戳（秒级）
        if (!timestamp) {
            timestamp = Math.floor(Date.now() / 1000);
        }

        // 标准化请求数据
        const normalizedData = Signature.normalizeData(data);

        // 按键名排序，确保签名的一致性
        const sortedKeys = Object.keys(normalizedData).sort();
        let signString = '';

        // 拼接排序后的参数为字符串
        sortedKeys.forEach((key, index) => {
            if (index > 0) signString += '&';
            signString += `${encodeURIComponent(key)}=${encodeURIComponent(normalizedData[key])}`;
        });

        // 添加时间戳和密钥到签名字符串
        signString += `&timestamp=${timestamp}&key=your_secret_key_here526fb87088aa9ac0bea25c0117f7e018`;
        console.log(signString)
        
        // 使用SHA256算法生成签名并返回
        return CryptoJS.SHA256(signString).toString()
    }

    /**
     * SHA256哈希函数
     * @param {string} str - 输入字符串
     * @returns {string} SHA256哈希值
     */
    static sha256(str) {
        return CryptoJS.SHA256(str).toString();
    }
}